import { render, staticRenderFns } from "./ForumEdit.vue?vue&type=template&id=49f71b15&"
import script from "./ForumEdit.vue?vue&type=script&lang=js&"
export * from "./ForumEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports